var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_32",
    "data-name": "Polygon 32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,57.09,17.45,70.26,25,83.42h15.1L47.7,70.26,40.13,57.09H25m-3.48-6H43.6l11,19.17-11,19.16h-22l-11-19.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_33",
    "data-name": "Polygon 33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,15.68,17.45,28.84,25,42h15.1L47.7,28.84,40.13,15.68H25m-3.48-6H43.6l11,19.16L43.6,48h-22l-11-19.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_34",
    "data-name": "Polygon 34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.41,36.27,52.83,49.44,60.41,62.6h15.1l7.58-13.16L75.51,36.27H60.41m-3.47-6H79L90,49.44,79,68.6h-22l-11-19.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/Skills.ba1a3092d31b88be39b2f5e961590f3c.svg";
export { ForwardRef as ReactComponent };